import { request } from '@/shared/io';
export async function getLogout(data) {
    return request(`/auth/logout?ct=1&userId=${data.id}&fp=${data.fp}&type=app&msg=1`, {
        method: 'get',
    });
}
